import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";

import * as CONST from "../../../includes/Constant";
import BlockLoading from "../../../blocks/BlockLoading";
import { S_FORMAT_INR_CURRENCY_AND_AMOUNT, S_FORMATE_INDIAN_NUMBERS } from "../../../includes/staticData";
import ViewClient from "../../modal/client/ViewClient";
import { AuthContext } from "../../../context/AuthContext";
import useAuthInfo from "../../../../hooks/IsAdmin";
import { Link } from "react-router-dom";
import { setGlobalModal } from "../../modal/GlobalModal";
import DashBoradTopPayingVendors from "../../modal/vendor/DashBoradTopPayingVendors";
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TopPayingVendorsChart = ({ searchParams }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const { isAdmin, eDepartmentId } = useAuthInfo();

  useEffect(() => {
    fetchTopPayingClients();
  }, [searchParams]);

  const fetchTopPayingClients = async () => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.DASH_TOP_PAYING_VENDORS, {
        params: {
          year: searchParams.year || "",
          department_id: searchParams.department_id || "",
          month: searchParams.month || "",
          limit: 10
        }
      });
      setData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const chartData = {
    labels: data.map((item) => item.vendor_name),
    datasets: [
      {
        label: "Total Paid",
        data: data.map((item) => item.vendor_payment),
        backgroundColor: "#dc3545", // Tailwind blue-500
        borderRadius: 0,
        barThickness: 20
      }
    ]
  };

  const options = {
    indexAxis: "y", // horizontal bar
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return S_FORMAT_INR_CURRENCY_AND_AMOUNT(context.raw);
          }
        }
      }
    },
    scales: {
      x: {
        ticks: {
          callback: (value) => S_FORMATE_INDIAN_NUMBERS(value)
        },
        grid: {
          drawOnChartArea: true
        }
      },
      y: {
        grid: {
          drawOnChartArea: false
        },
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value); // Get actual label
            const maxLength = 10; // Or use a word/char count
            return label.length > maxLength ? label.slice(0, maxLength) + '…' : label;
          },
          autoSkip: false, // Optional: prevent skipping if many labels
        },
      }
    }
  };

  return (
    <div className="card flex-fill">
      <div className="card-header">
        <div className="card-actions float-end">
          <div className="dropdown position-relative">
            <span className="badge badge-primary-light">
              <Link to="#" className="action"
                onClick={() =>
                  setGlobalModal(
                    DashBoradTopPayingVendors,
                    {
                      title: "",
                    },
                    {  // Modal Props
                      size: "lg",
                      title: "Top Paying Vendors",
                    }
                  )
                }
              >
                <i className="bx bx-info-circle"></i>
              </Link >
            </span>
          </div>
        </div>
        <h5 className="card-title mb-0">Top payments to vendors</h5>
      </div>
      <div className="card-body">
        {loading ? (
          <BlockLoading />
        ) : data.length > 0 ? (
          <Bar data={chartData} options={options} height={150} />
        ) : (
          <h5 className="text-muted text-center">No records found.</h5>
        )}
      </div>
    </div>
  );
};

export default TopPayingVendorsChart;
